'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ToolbarGridService = function ToolbarGridService() {
  function setStructureWithOldValues($scope, loadedData, rowid) {
    var columns = $scope.jqxGridSettings.columns;
    loadedData[rowid]._old = {};
    _.forEach(columns, function (col) {
      loadedData[rowid]._old[col.datafield] = undefined;
    });
  }
  function duplicate(rowToDuplicate, propertiesToDuplicate) {
    var row = _.clone(rowToDuplicate);
    _.forEach(row, function (value, property) {
      if (!_.includes(propertiesToDuplicate, property)) {
        delete row[property];
      }
    });
    row.isRowEditable = true;
    row.isRowRemovable = true;
    return row;
  }
  function addRow($scope, origin, destination) {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    loadedData.unshift({});
    loadedData[0].isRowRemovable = true;
    loadedData[0].origin = origin;
    loadedData[0].destination = destination;
    loadedData[0].isNewlyAdded = true;
    setStructureWithOldValues($scope, loadedData, 0);
    $scope.updateData(loadedData);
  }
  function addRowForFaresReopt($scope, pos, market, cabin) {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    loadedData.unshift({});
    loadedData[0].isRowRemovable = true;
    loadedData[0].pos = pos;
    loadedData[0].market = market;
    loadedData[0].cabin = cabin;
    loadedData[0].isNewlyAdded = true;
    setStructureWithOldValues($scope, loadedData, 0);
    $scope.updateData(loadedData);
  }
  function addRowsWithAdditionalData($scope, origin, destination, cabin, startDepartureDate, endDepartureDate) {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    loadedData.unshift({});
    loadedData[0].isRowRemovable = true;
    loadedData[0].origin = origin;
    loadedData[0].destination = destination;
    loadedData[0].cabin = cabin;
    loadedData[0].startDepartureDate = startDepartureDate;
    loadedData[0].endDepartureDate = endDepartureDate;
    loadedData[0].isNewlyAdded = true;
    setStructureWithOldValues($scope, loadedData, 0);
    $scope.updateData(loadedData);
  }
  function addOverBookingRows($scope, rows) {
    _.forEach(rows, function (row) {
      addRowsWithAdditionalData($scope, row.origin, row.destination, row.cabin, row.startDate, row.endDate);
    });
  }
  function duplicateRow($scope, propertiesToDuplicate) {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var selectedIndex = $scope.jqxGridSettings.jqxGrid('getselectedrowindex');
    var rowId = $scope.jqxGridSettings.jqxGrid('getrowid', selectedIndex);
    var oldRow = loadedData[rowId];
    var newRow = duplicate(oldRow, propertiesToDuplicate);
    loadedData.unshift(newRow);
    setStructureWithOldValues($scope, loadedData, 0);
    $scope.updateData(loadedData);
  }
  function removeRow($scope) {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var selectedIndex = $scope.jqxGridSettings.jqxGrid('getselectedrowindexes');
    _.remove(loadedData, function (value, index) {
      return _.includes(selectedIndex, index);
    });
    $scope.updateData(loadedData);
  }
  function rowSelectionHandler($scope, selectedRows) {
    $scope.isDuplicateButtonShown = selectedRows.length === 1;
    $scope.isDeleteButtonShown = selectedRows.length > 0 && _.every(selectedRows, function (element) {
      return element.isRowRemovable;
    });
    $scope.isReinitializeButtonShown = selectedRows.length > 0;
    $scope.selectedRows = selectedRows;
  }
  function validateReinitialization(selectedRows) {
    var invalidRows = _.filter(selectedRows, validateRow);
    if (invalidRows.length > 0) {
      displayErrors(getErrMessages(invalidRows[0]));
      return false;
    } else {
      return true;
    }
  }
  function validateRow(row) {
    return !row.origin || !row.destination || !row.startDepartureDate || !row.endDepartureDate;
  }
  function getErrMessages(row) {
    var errorMsg = [];
    if (!row.origin) {
      errorMsg.push('Origin has to be filled');
    }
    if (!row.destination) {
      errorMsg.push('Destination has to be filled');
    }
    if (!row.startDepartureDate || !row.endDepartureDate) {
      errorMsg.push('Begin and end date has to be filled');
    }
    return errorMsg;
  }
  function displayErrors(messages) {
    for (var i = 0; i < messages.length; i++) {
      toastr.error(messages[i]);
    }
  }
  return {
    addRow: addRow,
    duplicateRow: duplicateRow,
    removeRow: removeRow,
    rowSelectionHandler: rowSelectionHandler,
    addOverBookingRows: addOverBookingRows,
    validateReinitialization: validateReinitialization,
    addRowForFaresReopt: addRowForFaresReopt
  };
};
ToolbarGridService.$inject = [];
module.exports = ToolbarGridService;